// ─────────────────────────────────────────────
//  ProtectedRoute.js
//  Wraps any route that requires the user to
//  be logged in. Redirects to /login otherwise.
//  Usage in App.js:
//    <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
// ─────────────────────────────────────────────
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();

  if (!user) {
    // Pass the attempted URL so we can redirect back after login
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}
